import { DisabledPrompt, useBCMSModal } from "@bcm-dev/bcms-vite";
import { PrimaryButton, SecondaryButton } from 'components/ui';
import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter } from '../..';
import "./styles.css";

/**
 * @function TASPositivePayCancelEditChangeModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the TASPositivePayCancelEditChangeModal.
 */
export default function TASPositivePayCancelEditChangeModal(props) {
  const { onYesClick } = props.data ?? {};
  const { close } = useBCMSModal();

  const _onYesClick = () => {
    onYesClick();
    close("TASPositivePayCancelEditChangeModal");
  };
  const closeModal = evt => close("TASPositivePayCancelEditChangeModal");

  return (
    <CustomModal title="Cancel Change" id="TASPositivePayCancelEditChangeModal" 
    className="tas-positive-pay-cancel-edit-change-modal mobile-view-modal">
      <CustomModalContent>
        <p>Are you sure you want to cancel the change you have made?</p>
      </CustomModalContent>
      <CustomModalFooter>
        <SecondaryButton text="No" onClick={ closeModal } />
        <PrimaryButton className="set-width" text="Yes" onClick={ _onYesClick } />
      </CustomModalFooter>
    </CustomModal>
  );
}
